export const taskLabels = {
	['btn-submmit']: 'Finalizar',
	['btn-leave']: 'Abandonar',
	['btn-close']: 'Fechar',
	['btn-delete']: 'Deletar',
	['btn-sim-abandonar']: 'Sim, abandonar',
	['btn-nao-cancelar']: 'Não, cancelar',
	['btn-sim-deletar']: 'Sim, deletar',
	['btn-nao-deletar']: 'Não, deletar',
	['btn-sim-excluir']: 'Sim, excluir',
	['task']: 'Tarefa',
	['case']: 'Caso LB+',
	['caseLegacy']: 'Caso LB',
	['caseLegacyPreRegister']: 'Pré Cadastro',
	['area']: 'Área',
	['txt-abandon-task']: ['Deseja realmente', 'abandonar', 'essa tarefa?'],
	['txt-delete-task']: ['Deseja realmente', 'deletar', 'essa tarefa?'],
	['txt-isSpam-task']: ['Deseja realmente marcar como ', 'spam', 'essa tarefa?'],

	['txt-delete-pre-register']: ['Deseja realmente', 'excluir', 'esse pré-cadastro?'],
	['btn-progress']: 'Novo Andamento',
	['btn-diligence']: 'Nova Diligência',
	['btn-date-edit']: 'Alterar data',
	['label-date-edit']: ['Alterar', ' ', 'data'],
};
